import { getPrettyDateTime } from "../../../../utils/timestamp";

export const getColumns = (localTime) => [
  {
    field: "timestamp",
    headerName: "Event Time",
    width: 180,
    valueGetter: (params) => getPrettyDateTime(params.row.timestamp, localTime),
  },
  {
    field: "user_email",
    headerName: "User Email",
    width: 180,
  },

  {
    field: "event_message",
    headerName: "Event",
    width: 400,
    flex: 1,
  },
];
